import { render, staticRenderFns } from "./GroupDashboardOfficeSelector.vue?vue&type=template&id=163f92c2&"
import script from "./GroupDashboardOfficeSelector.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardOfficeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports